export enum ADFCalendarStateAction {
  /**
   * create a action variable in order to update state on ADF page
   */
  setContextState = 'update/wholeContext',
  setCalendarDate = 'select/DateOnCalendar',
}

export const REWARDS_REDEMPTION_CLUSTER_CODES = ['MRW', 'P17', '39E', 'MW1'];
